import { useRef, useEffect } from 'react';

/**
 * useEffect, but with a custom dependency array comparator.
 *
 * If the comparator returns false, the effect is run.
 */
function useComparableEffect(callback, deps, comparator) {
    const dependencies = useRef();
    if (dependencies.current === undefined ||
        !comparator(dependencies.current, deps)) {
        dependencies.current = deps;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(callback, dependencies.current);
}

export { useComparableEffect as default };
